export default __webpack_public_path__ + "static/media/parking_architecture.609e6031.jpg";